import { Route } from '@angular/router';
import { MainLayoutComponent } from '@vendorhub/shared/ui-layout';

export const appRoutes: Route[] = [
  {
    path: '',
    component: MainLayoutComponent,
    loadChildren: () =>
      import('@vendorhub/marketplace/feature-catalog').then((m) => m.catalogRoutes),
  },
];
